import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import DialogFactory from '../picker/dialogFactory';
import IPSDialog from '../picker/dialog';
import style from './style.vue';
import { IPSService } from '@/services/ipsServices';
import { PolicyTypeText } from '@/views/components/newDistribution/newDistributionList';

@DialogFactory
@Component({
  mixins: [style],
})
export default class ActivityLink extends IPSDialog {
  page = 1;

  pageSize = 10;

  total = 0;

  dataList = [];

  keyword = '';

  siteCodes = [];

  confirm = false;

  title = '选择分销角色';

  sgId = null;

  width = '800px';

  mounted() {
    this.getData();
  }

  getData() {
    IPSService.newDistributionList({
      postParams: {
        sgId: this.sgId,
        openState: 3,
        policyType: 9,
        keyword: this.keyword,
        page: this.page,
        pageSize: this.pageSize,
      },
    }).then((response) => {
      this.dataList = response.list;
      this.total = response.count;
    });
  }

  onSizeChange(val) {
    this.page = 1;
    this.pageSize = val;
    this.getData();
  }

  onPageChange(val) {
    this.page = val;
    this.getData();
  }

  onSelect(id, name) {
    this.$emit('result', { id, name });
    this.$emit('hidden');
  }

  handleSearch() {
    this.page = 1;
    this.getData();
  }

  renderContent(h) {
    return (
      <div class="select-list">
        <div class="filterController">
          <div class="inputWrapper">
            <el-input v-model={this.keyword} placeholder="角色标签/策略名称" />
            <i class="iconfont iconsousuo" onClick={this.handleSearch.bind(this)}></i>
          </div>
        </div>
        <el-table data={this.dataList} height="350px" style="width: 100%" tooltip-effect="light">
          <el-table-column type="index" label="ID" width="55" align="center" show-overflow-tooltip />
          <el-table-column prop="tagName" label="角色标签" show-overflow-tooltip={true} min-width={1} />
          <el-table-column prop="policyName" label="策略名称" show-overflow-tooltip min-width={2} />
          <el-table-column
            prop="policyType"
            label="策略类型"
            min-width={1}
            show-overflow-tooltip
            {...{
              scopedSlots: {
                default: (scope) => {
                  return <span>{PolicyTypeText[scope.row.policyType].text}</span>;
                },
              },
            }}
          />
          <el-table-column
            label="操作"
            min-width={1}
            align="center"
            {...{
              scopedSlots: {
                default: (scope) => {
                  return (
                    <span class="scopeSpan" onClick={this.onSelect.bind(this, scope.row.policyId, scope.row.policyName)}>
                      选中
                    </span>
                  );
                },
              },
            }}
          />
        </el-table>
        <div class="bottomWrapper">
          <el-pagination
            on-size-change={val => this.onSizeChange(val)}
            on-current-change={val => this.onPageChange(val)}
            current-page={this.page}
            page-sizes={[10, 15, 20, 30]}
            page-size={this.pageSize}
            layout="total, sizes, prev, pager, next, jumper"
            total={this.total}
          />
        </div>
      </div>
    );
  }
}
